var map = {
	"./autoParts.svg": 17759,
	"./bakery.svg": 16150,
	"./bar.svg": 47017,
	"./cellar.svg": 9635,
	"./coffeeShop.svg": 20598,
	"./electricMaterial.svg": 35648,
	"./hamburgueria.svg": 3388,
	"./nightclub.svg": 3120,
	"./petShop.svg": 2641,
	"./pizzeria.svg": 39316,
	"./restaurant.svg": 5563,
	"./snackBar.svg": 5487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53588;